import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import searchIcon from "../../../assets/images/search-normal.png";
import DropDown from "../../../assets/images/dropDownIcon.png";
import Warning from "../../../assets/images/warning-2.png";
import Mobile from "../../../assets/images/MOBILESCCS.png";
import OrderIcon from "../../../assets/images/orderProduct.png";
import calendar from "../../../assets/images/calendar-search.png";
import ErrorModal from "Components/Common/ErrorModal";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";


const DetailStatement = (props: any, IncomeDetailCount: any) => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const datepickerRef = useRef<any>(null);
  const endDatePickerRef = useRef<any>(null);

  useEffect(() => {
    console.log(props)
   }, [props, IncomeDetailCount]);

const downloadIncomeCSV = () => {
  const headers = [
    "Transaction Date",
    "Fee Name",
    "Statement Number",
    "Amount",
    "Product Name",
    "Order Number",
    "Order Line ID",
    "Comment"
  ];

  const rows = props.allIcomeDetailList?.map((item: any) => [
    item?.createdOn
      ? new Date(item.createdOn).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "-",
    item?.feeName || "Commission Fee",
    item?.statementNumber || "--",
    item?.breakdown?.amount || "0",
    item?.items?.[0]?.productName || "--",
    item?.id || "--",
    item?._id || "--",
    item?.comment || "No Comment"
  ]);

  const csvContent = [headers, ...(rows || [])]
    .map((row) =>
      row
        .map((cell: any) => `"${String(cell).replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "income_statement.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const [saveDate, setSaveDate] = useState<Date | null>(null);
  const [saveEndDate, setSaveEndDate] = useState<Date | null>(null);

   useEffect(() => {
    if (props.incomeDetailStartDate) {
      setSaveDate(new Date(props.incomeDetailStartDate));
    } else {
      setSaveDate(null);
    }
  
    if (props.incomeDetailEndDate) {
      setSaveEndDate(new Date(props.incomeDetailEndDate));
    } else {
      setSaveEndDate(null);
    }
  }, [props.incomeDetailStartDate, props.incomeDetailEndDate]); 

  const setStartDate = (date: Date | null) => {
    setSaveDate(date);
    const timestamp = date ? date.getTime() : null;
    props.onChange(timestamp);
  };

  const setEndDate = (date: Date | null) => {
    setSaveEndDate(date);
    const timestamp = date ? date.getTime() : null;
    props.onChangeEndDate(timestamp);
  };

 


  const handleReset = () => {
    setSaveDate(null);
    setSaveEndDate(null);
    props.resetBUtton()
  };



  return (
    <div>
      <ErrorModal
        show={showModal.isVisible}
        message={errorMessage}
        color={showModal.color}
        onCloseClick={() => setShowModal({ isVisible: false, color: false })}
      />
      <div className="DetailStatement">
        <div className="navigatiovCardDv">
          <Card className="w-100">
            <h6>Income Details</h6>
            <Row>
              <Col lg="5">
                <div className="Promotion-Main">
                  <div className="mainFields firstChi">
                    <div className="firstChilde">
                      <div className="headindg">Order Creation Date</div>
                      <div style={{ position: "relative" }}>
                        <DatePicker
                          ref={datepickerRef}
                          selected={saveDate}
                          onChange={setStartDate}
                          placeholderText="Start Date"
                          dateFormat="yyyy-MM-dd"
                          minDate={new Date()}
                          className="form-control"
                        />

                        <img
                          src={calendar}
                          alt="calendar"
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "10px",
                            width: "16px",
                            height: "16px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (datepickerRef.current) {
                              datepickerRef.current.setFocus();
                            }
                          }}
                        />
                      </div>
                      <div style={{ position: "relative" }}>
                        <DatePicker
                          ref={endDatePickerRef}
                          selected={saveEndDate}
                          onChange={setEndDate}
                          placeholderText="End Date"
                          dateFormat="yyyy-MM-dd"
                          minDate={new Date()}
                          className="form-control"
                        />

                        <img
                          src={calendar}
                          alt="calendar"
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "10px",
                            width: "16px",
                            height: "16px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (endDatePickerRef.current) {
                              endDatePickerRef.current.setFocus();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </Col>
              <Col lg="5">
                <div className="mainFields selecDv">
                  <div className="firstChilde">
                    <div className="headindg">
                      <p>Release Status </p>{" "}
                    </div>
                    <select onChange={props.onStatusChange} value={props.selectedStatus || ""} >
                      <option value="">All</option>
                      <option value="released">Released</option>
                      <option value="toBeReleased">Released To Be</option>
                    </select>
                  </div>
                </div>
              </Col>
              <Col lg="2">
                <div className="Reset">
                  <button onClick={handleReset}>Reset</button>
                </div>
              </Col>
              <Col lg="5">
                <div></div>
                <div className="mainFields firstChi mt-2">
                  <div className="firstChilde">
                    <div className="headindg">Statement Number</div>
                    <input
                      type="text"
                      value={props.search}
                      onChange={(e) => props.onSearch(e.target.value)}
                    />
                  </div>
                  <img src={searchIcon} alt="" className="icon" data-testing-id="SearchICon" />
                </div>{" "}
              </Col>
            </Row>
            <Row>
              <Col lg="10">
                <div className="Ampont-Dev-content">
                  <div className="box-Div">
                    <div className="box-content">
                      <div className="Amount">
                        <h5>Total Amount</h5>
                        <img src={Warning} alt="" />
                      </div>
                      <h3>
                        Rs.{" "}
                        <span>
                          {props?.IncomeDetailCount?.totalAmount || 0}
                        </span>
                      </h3>
                    </div>
                  </div>

                  <div className="box-Div">
                    <div className="box-content">
                      <div className="Amount">
                        <h5>Revenue</h5>
                        <img src={Warning} alt="" />
                      </div>
                      <h3>
                        Rs.{" "}
                        <span>{props?.IncomeDetailCount?.revenue || 0}</span>
                      </h3>
                    </div>
                  </div>

                  <div className="box-Div">
                    <div className="box-content">
                      <div className="Amount">
                        <h5>Deductions</h5>
                        <img src={Warning} alt="" />
                      </div>
                      <h3>
                        Rs.{" "}
                        <span>{props?.IncomeDetailCount.deduction || 0}</span>
                      </h3>
                    </div>
                  </div>
                </div>
              </Col>

              <Col lg="2">
                <div className="Download" onClick={downloadIncomeCSV}>
                  {/* <select
                    data-testing-id="statusSelect_PromotionListing"
                   >
                    <option
                      value=""
                      data-testing-id="selectStatusOption_PromotionListing"
                    >
                      Download
                    </option>
             
                  </select> */}
                  <div className="button">
                    <h6>Download</h6>
                    <img src={DropDown} alt="" />
                  </div>
                </div>
              </Col>
              <div className="STATE-ment">
                <div className="GirdWidth ">
                  <div className="girdOne">
                    <input type="checkbox"  data-testing-id="CheckBOX"/>
                    <p>Transaction </p>
                  </div>
                  <div className="girdTwo">
                    <p>Fee Name</p>
                  </div>
                  <div className="girdThree">
                    <p>Statement Number</p>
                  </div>
                  <div className="girdFour">
                    <p>Amount</p>
                  </div>
                  <div className="girdFive">
                    <p>Order Details</p>
                  </div>
                  <div className="girdSix">
                    <p>Comment</p>
                  </div>
                  <div className="girdSeven">
                    <p>Action</p>
                  </div>
                </div>
              </div>
            </Row>
          </Card>
        </div>
        {props?.allIcomeDetailList?.length > 0 ? (
          props.allIcomeDetailList.map((item: any, index: number) => (
            <Card className="" key={index}>
              <div>
                <div className="GirdWidth">
                  <div className="girdOne">
                    <input type="checkbox" />
                    <p>
               {item?.createdOn
  ? new Date(item.createdOn).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  : "-"}

                    </p>
                  </div>
                  <div className="girdTwo">
                    <p>{item?.feeName || "Commission Fee"}</p>
                  </div>
                  <div className="girdThree">
                    <p>{item?.statementNumber || "--"}</p>
                  </div>
                  <div className="girdFour">
                    <p>
                      Rs <span>{item?.breakdown?.amount || "0"}</span>
                    </p>
                  </div>
                  <div className="girdFive">
                    <div className="boX">
                      <img
                        src={
                          item?.items?.[0]?.productImage ||
                          OrderIcon
                        }
                        alt=""
                      />
                      <div>
                        <p className="orderHeading">
                          {item?.items?.[0]?.productName || "--"}
                        </p>
                        <p className="potable">
                          Order Number:
                          <span className="textOver">
                            {item?.id || "--"}
                          </span>
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              navigator.clipboard.writeText(
                                item?.id
                              );
                              setShowModal({ isVisible: true, color: true });
                              setErrorMessage("Order Number Copied!.");
                              setTimeout(() => {
                                setShowModal({ isVisible: false, color: true });
                              }, 1000);
                            }}
                          >
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                        <p className="potable">
                          Order Line ID:
                          <span className="textOver">
                            {item?.buypassId || item?._id || "--"}
                          </span>
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              navigator.clipboard.writeText(
                                item?._id
                              );
                              setShowModal({ isVisible: true, color: true });
                              setErrorMessage("Order Number Copied!.");
                              setTimeout(() => {
                                setShowModal({ isVisible: false, color: true });
                              }, 1000);
                            }}
                          >
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="girdSix">
                    <p>
                      {item?.comment || "No Comment"}
                    </p>
                  </div>
                  <div className="girdSeven">
                    <Link to={`/Detail-order/${item.orderId}`}>
                      <p>View Orders Details</p>
                    </Link>
                    <Link to={`/stateMentOverview/${item._id}`}>
                      <p>View Statement Details</p>
                    </Link>
                  </div>
                </div>
              </div>
            </Card>
          ))
        ) : (
          <div className="noDataFound">
            <p className="text-center fs-3">No Data Found !</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailStatement;
